import React from 'react';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
type TrustStripProps = {
  className?: string;
  /** 'short' is the 3-item strip under a CTA, 'full' adds the payment and format items. */
  variant?: 'short' | 'full';
};
const SHORT = [{
  Icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  Icon: LockIcon,
  label: 'Secure payment'
}, {
  Icon: CreditCardIcon,
  label: 'Credit card'
}];
const FULL = [{
  Icon: ZapIcon,
  label: 'Access in 5 minutes'
}, {
  Icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  Icon: CreditCardIcon,
  label: 'Stripe · PayPal · Local currency'
}, {
  Icon: FileTextIcon,
  label: '100% PDF'
}];
export function TrustStrip({
  className = '',
  variant = 'short'
}: TrustStripProps) {
  const items = variant === 'full' ? FULL : SHORT;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-227" data-mp="3urpsvo0bbl5x">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-228" data-mp="3muxn7onkbrdt">
          <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-229" data-mp="3rt8xg0hrs3wk" />
          {label}
        </li>)}
    </ul>;
}